import { createFileRoute } from "@tanstack/react-router";
import { WopiFilePage } from "src/components/views/documents/wopi/WopiFilePage.tsx";

export const Route = createFileRoute("/wopi/$action/$fileId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { action, fileId } = Route.useParams();
	return <WopiFilePage action={action} fileId={fileId} />;
}
